import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { UUID } from 'angular2-uuid';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { CropsService } from 'src/app/shared/services/crops.service';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.sass']
})
export class CategoryComponent implements OnInit {

  cropCategoryArray: any = [];
  showPage: boolean = true;
  showCategory: string = 'category';
  categoryObj: any = {};
  categoryForm: FormGroup;
  loading: boolean;
  globalImgUrl: string;
  groupName: string;
  collectionSize: any;
  previousPage: number;
  skip: any;
  page = 1;
  type: string = 'save';
  searchStr: string = '';
  categoryImage: any;
  url: string = '';
  imageUploadService: string;
  cropUuid: string = '';
  componentData: any;
  selectedCrop: any;
  cropVarietiesArray: any = [];

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private fileUploadService: FileUploadService,
    private cropsService: CropsService,
    private cognitoService: CognitoService) { }

  ngOnInit() {
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.globalImgUrl = this.authService.s3url();
      this.getAllCategory(0);
    })
    this.type = 'save';
    this.categoryForm = this.formBuilder.group({
      categoryName: ['', Validators.required],
    });
  }
  getAllCategory(skip) {
    this.loading = true;
    this.showPage = true;
    this.cropCategoryArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip
      // }
    }
    console.log("@@options in get categories:", options)
    this.cropsService.getCategories(options).then((data: any) => {
      console.log("crop category Data == ", data);
      if (data.length > 0) {
        this.cropCategoryArray = data;
        console.log("cropCategoryArray", this.cropCategoryArray)
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName }
    console.log("@@get all category object:", count)
    this.cropsService.getCategoriesCount(count).then((data: any) => {
      console.log("category COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  loadPage(pageNumber: number, type) {
    // this.loading = true;
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      if (type == 'category') {
        this.getAllCategory(this.skip);
      } else {
        this.getVarietiesByCropId(this.skip, this.selectedCrop);
      }
    }
  }

  addCategory() {
    this.type = 'save';
    this.categoryForm.reset();
    this.showCategory = 'addCategory';
  }

  getCropDataByCategory(record) {
    this.componentData = record;
    this.showCategory = 'crops';
  }

  getVarietiesByCrop(skip, record) {
    console.log("record", record);
    if (record) {
      this.getVarietiesByCropId(skip, record)
    } else {
      this.showCategory = 'category';
      this.getAllCategory(0);
    }
  }

  getVarietiesByCropId(skip, crop) {
    this.loading = true;
    this.selectedCrop = crop;
    this.showCategory = 'varieties';
    this.showPage = true;
    this.cropVarietiesArray = [];
    var options = {
      group: this.groupName,
      maincropId: crop.maincropId,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip
      // }
    }
    this.cropsService.getCropVarieties(options).then((data: any) => {
      console.log("cropData == ", data);
      if (data.length > 0) {
        this.cropVarietiesArray = data;
        console.log("varietyarray", this.cropVarietiesArray)
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = {
      group: this.groupName,
      maincropId: crop.maincropId
    }
    this.cropsService.getCropVarietiesCount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  backToCrops() {
    this.showCategory = 'crops';
  }

  mainImageInput(event) {
    console.log("event : ", event);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.url = event.target.result;
      }
      this.cropUuid = this.cropUuid ? this.cropUuid : UUID.UUID();
      this.imageUploadService = this.cropUuid + "." + event.target.files.item(0).type.split('/')[1];
      this.categoryImage = event.target.files[0]
      console.log("categoryImage", this.categoryImage)
    }
  }

  deleteImage() {
    this.url = '';
    this.imageUploadService = '';
  }

  uploadFileToActivity() {
    console.log("dd ", this.imageUploadService, this.categoryImage)
    this.fileUploadService.uploadFile(this.categoryImage, this.imageUploadService);
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  cancelCategory() {
    this.url = '';
    this.imageUploadService = '';
    this.categoryForm.reset();
    this.showCategory = 'category';
    this.getAllCategory(0);
  }

  editCategory(record) {
    this.url = '';
    this.cropUuid = '';
    this.imageUploadService = '';
    this.type = 'update';
    this.showCategory = 'addCategory';
    this.categoryObj = record;
    this.cropUuid = record.categoryId
    this.url = this.globalImgUrl + this.categoryObj.categoryImage;
    this.imageUploadService = this.categoryObj.categoryImage;
    console.log("categoryObj", this.categoryObj);
  }

  saveData() {
    this.loading = true;
    // let uuid = UUID.UUID();
    this.categoryObj.categoryId = this.cropUuid;
    this.categoryObj.group = this.groupName;
    this.categoryObj.categoryImage = this.imageUploadService;
    console.log("category obj : ", JSON.stringify(this.categoryObj));
    this.uploadFileToActivity();
    this.cropsService.createCropCategory(this.categoryObj).then((data: any) => {
      console.log("save category result : ", JSON.stringify(data));
      if (data) {
        Swal({ title: "saved successfully!" });
        this.type = 'save';
        this.url = '';
        this.cropUuid = '';
        this.imageUploadService = '';
        this.categoryForm.reset();
        this.showCategory = 'category';
        this.getAllCategory(0);
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  updateCropCategory() {
    this.loading = true;
    this.categoryObj.categoryImage = this.imageUploadService;
    if (this.categoryImage != undefined) {
      this.uploadFileToActivity();
    }
    console.log("update categoryObj", this.categoryObj);
    delete this.categoryObj._id
    this.cropsService.updateCropCategory(this.categoryObj).then((data: any) => {
      console.log("updateData result : ", JSON.stringify(data));
      if (data) {
        this.type = 'save';
        Swal({ title: "Updated successfully" })
        this.url = '';
        this.cropUuid = '';
        this.imageUploadService = '';
        this.showCategory = 'category';
        this.getAllCategory(0);
        this.categoryForm.reset();
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not updated (please contact admin)',
          'error'
        )
      }
    })
  }

  searchByName() {
    if (this.searchStr != '') {
      this.loading = true;
      var obj = {
        group: this.groupName,
        field: 'categoryName',
        text: this.searchStr,
        tableName: 'cropcategory',
      };
      console.log("search obj : ", obj)
      this.cropsService.getCropCategoryRegex(obj).then((data: any) => {
        console.log("searched", data)
        this.searchStr = '';
        this.cropCategoryArray = [];
        if (data.length > 0) {
          this.cropCategoryArray = data;
          this.showPage = false;
          this.loading = false;
          console.log("cropCategoryArray", this.cropCategoryArray);
        }
        else {
          this.loading = false;
          this.showPage = false;
        }
      })
    }
  }

  searchByVarietyName() {
    if (this.searchStr != '') {
      var obj = {
        group: this.groupName,
        field: 'varietyName',
        text: this.searchStr,
        tableName: 'cropvarieties',
      };
      console.log("search obj : ", obj)
      this.cropsService.getcropvarietiesRegex(obj).then((data: any) => {
        console.log("searched", data)
        this.searchStr = '';
        this.cropVarietiesArray = [];
        if (data.length > 0) {
          this.cropVarietiesArray = data;
          this.showPage = false;
          console.log("cropVarietiesArray", this.cropVarietiesArray);
        }
        else {
          this.showPage = false;
        }
      })
    }
  }
}